module.exports = __webpack_public_path__ + "static/media/multiple-choice-image-snail-trail.64109c71.svg";